import {
  CANCEL_REPLAY_TO_COMMENT,
  CANCEL_UPDATE_COMMENT,
  CHANGE_COMMENT_COUNT,
  CHANGE_COMMENT_FIELD,
  CHANGE_COMMENT_SUBMIT_STATUS,
  CHANGE_COMMENTS_DATA,
  CHANGE_MORE_COMMENTS_DATA,
  HANDLE_ADD_COMMENT,
  HANDLE_DELETE_COMMENT,
  HANDLE_DELETE_INNER_COMMENT,
  HANDLE_GET_COMMENT_REPLIES,
  HANDLE_REPLY_TO_COMMENT,
  HANDLE_UPDATE_COMMENT,
  HANDLE_UPDATE_INNER_COMMENT,
  READY_TO_REPLY_COMMENT,
  READY_TO_UPDATE_COMMENT,
} from '../../actions/types';

const initialState = {
  postId: '',
  productType: '',
  count: 0,
  commentsData: {
    edges: [],
    pageInfo: {
      endCursor: '',
      hasNextPage: false,
    },
  },
  submitting: false,
  commentText: '',
  updatingCommentData: {
    commentId: '',
    innerCommentId: '',
  },
  replyingCommentData: {
    commentId: '',
    innerCommentId: '',
    commentAuthor: '',
  },
  activeCommentId: '',
  activeCommentRepliesData: {
    edges: [],
    pageInfo: {
      endCursor: '',
      hasNextPage: false,
    },
  },
  latestInnerCommentId: '',
};

export default  (state = initialState, action) => {
  switch (action.type) {
    case CHANGE_COMMENT_COUNT:
      return {
        ...state,
        count: action.payload,
      };
    case CHANGE_COMMENTS_DATA:
      return {
        ...state,
        postId: action.payload.postId,
        productType: action.payload.productType,
        commentsData: action.payload.commentsData,
        commentText: '',
        updatingCommentData: {
          commentId: '',
          innerCommentId: '',
        },
        replyingCommentData: {
          commentId: '',
          innerCommentId: '',
          commentAuthor: '',
        },
        activeCommentId: '',
        activeCommentRepliesData: {
          edges: [],
          pageInfo: {
            endCursor: '',
            hasNextPage: false,
          },
        },
        latestInnerCommentId: '',
      };
    case CHANGE_MORE_COMMENTS_DATA:
      return {
        ...state,
        commentsData: {
          edges: action.payload.edges,
          pageInfo: action.payload.pageInfo,
        },
      };
    case CHANGE_COMMENT_FIELD:
      return {
        ...state,
        commentText: action.payload,
      };
    case  CHANGE_COMMENT_SUBMIT_STATUS:
      return {
        ...state,
      };
    case HANDLE_ADD_COMMENT:
      return {
        ...state,
        count: state.count + 1,
        commentText: '',
        commentsData: {
          ...state.commentsData,
          edges: action.payload,
        },
      };
    case READY_TO_UPDATE_COMMENT:
      return {
        ...state,
        commentText: action.payload.commentText,
        updatingCommentData: {
          commentId: action.payload.commentId,
          innerCommentId: action.payload.innerCommentId,
        },
        replyingCommentData: {
          commentId: '',
          innerCommentId: '',
          commentAuthor: '',
        },
      };
    case CANCEL_UPDATE_COMMENT:
      return {
        ...state,
        commentText: '',
        updatingCommentData: {
          commentId: '',
          innerCommentId: '',
        },
      };
    case  HANDLE_UPDATE_COMMENT:
      return {
        ...state,
        commentsData: {
          ...state.commentsData,
          edges: action.payload,
        },
        updatingCommentData: {
          commentId: '',
          innerCommentId: '',
        },
        commentText: '',
      };
    case HANDLE_UPDATE_INNER_COMMENT:
      return {
        ...state,
        activeCommentRepliesData: {
          ...state.activeCommentRepliesData,
          edges: action.payload,
        },
        updatingCommentData: {
          commentId: '',
          innerCommentId: '',
        },
        commentText: '',
      };
    case READY_TO_REPLY_COMMENT:
      return {
        ...state,
        replyingCommentData: {
          commentId: action.payload.commentId,
          innerCommentId: action.payload.innerCommentId,
          commentAuthor: action.payload.commentAuthor,
        },
        updatingCommentData: {
          commentId: '',
          innerCommentId: '',
        },
        commentText: '',
      };
    case CANCEL_REPLAY_TO_COMMENT:
      return {
        ...state,
        replyingCommentData: {
          commentId: '',
          innerCommentId: '',
          commentAuthor: '',
        },
        commentText: '',
      };
    case HANDLE_REPLY_TO_COMMENT:
      return {
        ...state,
        commentsData: {
          ...state.commentsData,
          edges: action.payload.commentEdges,
        },
        activeCommentId: action.payload.activeCommentId,
        activeCommentRepliesData: action.payload.activeCommentRepliesData,
        latestInnerCommentId: action.payload.latestInnerCommentId,
        replyingCommentData: {
          commentId: '',
          innerCommentId: '',
          commentAuthor: '',
        },
        commentText: '',
      };
    case HANDLE_GET_COMMENT_REPLIES:
      return {
        ...state,
        activeCommentId: action.payload.activeCommentId,
        activeCommentRepliesData: {
          edges: action.payload.edges,
          pageInfo: action.payload.pageInfo,
        },
      };
    case HANDLE_DELETE_COMMENT:
      return {
        ...state,
        count: state.count - 1,
        commentsData: {
          ...state.commentsData,
          edges: action.payload,
        },
      };
    case HANDLE_DELETE_INNER_COMMENT:
      return {
        ...state,
        activeCommentRepliesData: {
          ...state.activeCommentRepliesData,
          edges: action.payload,
        },
      };
    default:
      return state;
  }
};
